import { TextFormat } from 'V2/Types';

export const toTitleCase = (value: string): string => {
  return value
    .toLowerCase()
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

export const combineStrings = (args: Array<string | number>) => {
  if (!args.length) return '';
  return args
    .join(' ')
    .replace(/\s{2,}/, ' ')
    .replace(/^\s+|\s+$/, '')
    .trim();
};

export const toSnakeCase = (value: string): string => {
  if (!value) return '';
  return value.replace(/([a-z])([A-Z])/g, '$1_$2').toLowerCase();
};

export const toCamelCase = (value: string): string => {
  if (!value) return '';
  return value.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());
};

export const formatText = (value: string, format: TextFormat): string => {
  switch (format) {
    case 'lowercase':
      return value.toLowerCase();
    case 'uppercase':
      return value.toUpperCase();
    case 'capitalize':
    default:
      return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
  }
};

export const fromUnderscoreToDash = (value: string): string => {
  return value.replace(/_/g, '-');
};

export const fromCamelToKebab = (value: string): string => {
  return value.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
};

export const capitalizeFirstLetter = (frequencyLabel: string): string => {
  if (!frequencyLabel) return '';

  return frequencyLabel.charAt(0).toUpperCase() + frequencyLabel.slice(1);
};

export function toSentenceCase(
  text: string,
  wordsToPreserve: string[] = []
): string {
  if (!text) return text;

  const trimmed = text.trim();

  // Extract trailing punctuation (?, !, .)
  const punctuationMatch = trimmed.match(/[?.!]+$/);
  const punctuation = punctuationMatch ? punctuationMatch[0] : '';
  const content = punctuation ? trimmed.slice(0, -punctuation.length) : trimmed;

  const preserveSet = new Set(wordsToPreserve);

  const words = content.split(/\s+/);

  const processed = words.map((word, index) => {
    if (preserveSet.has(word)) return word;

    const lowerCased = word.toLowerCase();

    if (index === 0) {
      return lowerCased.charAt(0).toUpperCase() + lowerCased.slice(1);
    }

    return lowerCased;
  });

  return processed.join(' ') + punctuation;
}
